import React from 'react';
import DateRangePicker from '../../../../../../../components/datePicker/DateRangePicker';
import Select from '../../../../../../../components/input/Select';
import {
  DATE_FORMAT,
  DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT,
} from '../../../../../../../constants/service/common/utilConstants';
import { TAG_LOG_TYPE_TEXT, TAG_LOG_TYPE_SELECT_LIST } from '../../../../../../../constants/service/app/tagConstants';
import { addAllItemToSelectList } from '../../../../../../../lib/common';
import { setDateFormat } from '../../../../../../../lib/moment';

/**
 *  유저 태그 타임라인 리스트 컬럼
 */
const columns = (data) => {
  const { filterOption, onFilter } = data;

  return [
    {
      accessor: 'no',
      Header: '순번',
      Cell: (row) => row.value,
    },
    {
      accessor: 'actionLogType',
      Header: '활동 내역',
      filterable: true,
      Cell: (row) => TAG_LOG_TYPE_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(TAG_LOG_TYPE_SELECT_LIST)}
          onChange={(actionLogType) => onFilter({ actionLogType })}
          value={filterOption.actionLogType}
          isTable
          size="large"
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '활동 시간',
      filterable: true,
      sortable: true,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          showTime={true}
          btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          startText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          endText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          format={DATE_FORMAT.FULL_DASH_FORMAT}
          onSelect={(createDate) => onFilter({ createDate })}
        />
      ),
    },
  ];
};

export default columns;
